import AutoCompleteFilter from "../../../../../components/AutoCompleteFilter";
import InputSelect from "../../../../../components/InputSelect";
import baseService from "../../../../../services/baseService";

export const inputsFiltersTypes = ({
  localFilterValues,
  handleFilterChange,
}) => [
  {
    label: "Nome",
    component: (
      <AutoCompleteFilter
        service={baseService}
        columnDataBase="name"
        model="type"
        value={localFilterValues.name}
        onChange={(selected) => handleFilterChange("name", selected)}
        placeholder="Filtre os tipos pelo nome"
        isMulti
        isClearable
      />
    ),
  },
  {
    label: "É kit",
    component: (
      <InputSelect
        value={localFilterValues.is_kit}
        onChange={(e) => handleFilterChange("is_kit", e.target.value)}
        helperText="Filtre os tipos pela condição"
        options={[
          { value: 1, label: "Sim" },
          { value: 0, label: "Não" },
        ]}
      />
    ),
  },
];
